"use client";

import { Quote } from "lucide-react";
import type React from "react";

export interface FooterQuoteProps {
  quote: string;
  author: string;
}

const FooterQuote: React.FC<FooterQuoteProps> = ({ quote, author }) => {
  return (
    <div className="bg-white/20 border border-white/30 rounded-3xl p-16 mb-16 backdrop-blur-sm text-center">
      <div className="max-w-4xl mx-auto">
        <Quote className="w-12 h-12 text-black/30 mx-auto mb-8" />
        <blockquote className="text-3xl md:text-4xl font-light text-black leading-relaxed mb-8 italic">
          "{quote}"
        </blockquote>
        <div className="flex items-center justify-center gap-4">
          <div className="w-16 h-px bg-black/30"></div>
          <cite className="text-black/70 font-medium not-italic">{author}</cite>
          <div className="w-16 h-px bg-black/30"></div>
        </div>
      </div>
    </div>
  );
};

export default FooterQuote;
